import { registerPlugin } from "@capacitor/core";

import type { SafeAreaPlugin } from "./definitions";

const SafeArea = registerPlugin<SafeAreaPlugin>("SafeArea", {
    "web": async () => import("./web").then((module) => new module.SafeAreaWeb()),
});

export * from "./definitions";

export { SafeArea };
